<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            label="Currency Code"
            prepend-icon="mdi-magnify"
            v-model="currencyCode"
            @input="syncFiltered()"
            solo
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-simple-table class="elevation-10">
        <template v-slot:default>
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Currency Code</th>
              <th scope="col">Display Code</th>
              <th scope="col">Iso Code</th>
              <th scope="col">Decimal Number</th>
              <th scope="col">Overwrite Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="currency in currencies"
              v-if="isCurrencyFiltered(currency)"
            >
              <td>{{ currency.id }}</td>
              <td>{{ currency.currencyCode }}</td>
              <td>{{ currency.displayCode }}</td>
              <td>{{ currency.isoCode }}</td>
              <td>{{ currency.decimalNumber }}</td>
              <td>{{ currency.overwriteDate }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { parameters } from "../../../parameters";
import { httpClient } from "../../../requesters/httpClient";

export default {
  name: "CurrenciesOverwritten",
  data() {
    return {
      currencies: [],
      currencyCode: "",
    };
  },
  async mounted() {
    await httpClient
      .get(`${parameters.posdataRefUrl}/currency-overwrittens`)
      .then((response) => {
        this.currencies = response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {
    isCurrencyFiltered: function (currency) {
      return (
        this.currencyCode === null || this.currencyCode === "" || this.currencyCode === currency.currencyCode
      );
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/components/overwritten/currencies/Currencies.vue